import { render, staticRenderFns } from "./PhotoSection.vue?vue&type=template&id=49e8a3fc&scoped=true&"
import script from "./PhotoSection.vue?vue&type=script&lang=js&"
export * from "./PhotoSection.vue?vue&type=script&lang=js&"
import style0 from "./PhotoSection.vue?vue&type=style&index=0&id=49e8a3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e8a3fc",
  null
  
)

export default component.exports